import { Typography } from "@mui/material";

const LoadingReport = () => {
    return (
        <Typography
            style={{ textAlign: "center", fontSize: "small" }}
        >
            Your reports are being generated. They will
            automatically appear on screen once ready.
        </Typography>
    )
}
export default LoadingReport;